import { Component, Input, OnChanges } from '@angular/core';

/**
 * 
 * This can be used as:
 * 
 * <ac-cta-link icon="arrow-right" (click)="doSomething()">
 * 	<span dcrHTMLKey="AA">BBB</span>
 * </ac-cta-link>
 * 
 * <ac-cta-link icon="arrow-right" [link]="someLink">
 * 	<span dcrHTMLKey="AA">BBB</span>
 * </ac-cta-link>
 * 
 * This will eventually be ported to daisy's dz-link
 */
@Component({
	selector: 'ac-cta-link',
	templateUrl: './cta-link.component.html',
	styleUrls: ['./cta-link.component.scss']
})
export class CtaLinkComponent implements OnChanges {

	@Input() public icon: string;
	@Input() public link: any;
	@Input() public class: any;
	@Input() public trackEvent: string; // For analytics

	public isExternalLink: boolean = false;
	public isInternalLink: boolean = false;

	public ngOnChanges(): void {
		const linkAsString = this.link?.toString();
		this.isExternalLink = linkAsString?.startsWith('http') || linkAsString?.startsWith('mailto');
		this.isInternalLink = this.link && !this.isExternalLink;
	}

}
